export const PostBadge = (props) => {
  return (
    <div className={props.style}>
      {props.link ? (
        <a href={props.linkUrl || "#"}>
          <p className={`badge rounded-pill bg-${props.color}`}>{props.text}</p>
        </a>
        
      ) : (
        <p className={`badge rounded-pill bg-${props.color}`}>{props.text}</p>
      )}
    </div>
  );
};
